<template>
  <div>
    <v-btn
      ref="dragButton"
      color="#8165D1"
      :class="`updates-btn ${
        isSupportChatOpened
          ? isChatWidgetOpened
            ? 'float-with-chat-opened'
            : 'float-with-chat-closed'
          : 'floating-button'
      }`"
      :min-width="!showGuideMenu ? '157px' : '0px'"
      height="38px"
      :style="`text-transform: none; font-size: 12px; padding: 0px ${
        !showGuideMenu ? 'border-radius: 100%; padding: 8px' : ''
      }`"
      @click="handleToggleClick"
      @mousedown.stop="startDrag($event, true)"
      @touchstart.stop.prevent="startDrag($event, true)"
    >
      <div v-if="!showGuideMenu">
        <v-icon left class="ml-0">ph ph-shooting-star</v-icon>
        {{ $t("guide.guideTitle") }}
        <v-icon
          v-if="!showGuideMenu"
          right
          @click.stop=""
          style="
            background-color: #947cd8;
            border-radius: 100%;
            padding: 13px;
            margin-right: 0px;
          "
          @click="closeFloatingGuide"
          >ph-x</v-icon
        >
      </div>
      <v-icon v-else class="pa-2">ph-caret-down</v-icon>
    </v-btn>

    <div
      ref="guideList"
      v-if="showGuideMenu && didntChooseGuide && !showCompleteGuide"
      :class="`guide-container ${
        isSupportChatOpened
          ? isChatWidgetOpened
            ? 'next-to-opened-chat'
            : 'next-to-chat-closed'
          : 'float-guide'
      } elevation-6`"
      @mousedown.stop="startDrag($event)"
      @touchstart.stop.prevent="startDrag($event)"
    >
      <v-card-title
        class="px-0 d-flex flex-column align-start ml-2"
        style="gap: 4px"
      >
        <p
          class="title-guide"
          v-html="
            allOnboardingsCompleted
              ? $t('guide.completedOnboarding.title')
              : $t('guide.initOnboarding.title')
          "
        ></p>
        <p
          class="subtitle-guide"
          v-html="
            allOnboardingsCompleted
              ? $t('guide.completedOnboarding.subtitle')
              : $t('guide.initOnboarding.subtitle')
          "
        ></p>
      </v-card-title>

      <v-card
        class="mt-0"
        style="
          box-shadow: unset;
          border: 1px solid #c1c1c1;
          border-radius: 14px !important;
        "
      >
        <v-card-text max-heigth="354px">
          <v-list dense :width="355" :height="235" style="overflow: auto">
            <v-list-item
              v-for="(item, index) in onboardingTopicsDetails"
              :key="index"
              @click="openOnboardingDetails(index)"
              class="px-2"
            >
              <v-checkbox
                :input-value="isCompleted(item.onboarding_code)"
                :disabled="isCompleted(item.onboarding_code)"
                color="primary"
                hide-details
                dense
                @click.stop="handleCheckboxClick(item)"
                class="pb-2"
              ></v-checkbox>
              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-medium"
                  :class="{
                    'completed-text': isCompleted(item.onboarding_code),
                  }"
                  >{{ item.title }}</v-list-item-title
                >
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>ph-caret-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>

      <v-btn
        class="mt-5"
        outlined
        color="primary"
        @click="showCompleteGuide = true"
        style="
          border: 1px solid #c1c1c1;
          border-radius: 14px !important;
          text-transform: none;
          background-color: white;
        "
      >
        <v-icon right class="mr-2">ph ph-rocket</v-icon>
        {{ $t("guide.completeGuide.button") }}
        <v-spacer />
        <v-icon left>ph-caret-right</v-icon>
      </v-btn>
    </div>

    <div
      ref="guideComplete"
      v-if="showGuideMenu && didntChooseGuide && showCompleteGuide"
      :class="`guide-container ${
        isSupportChatOpened
          ? isChatWidgetOpened
            ? 'next-to-opened-chat'
            : 'next-to-chat-closed'
          : 'float-guide'
      } elevation-6`"
      @mousedown.stop="startDrag($event)"
      @touchstart.stop.prevent="startDrag($event)"
    >
      <v-card-title class="px-0">
        <v-btn icon @click="showCompleteGuide = false">
          <v-icon size="30px" color="white">ph-caret-left</v-icon>
        </v-btn>
        <p class="title-guide" v-html="$t('guide.completeGuide.title')"></p>
      </v-card-title>

      <v-card
        class="mt-0"
        style="
          box-shadow: unset;
          border: 1px solid #c1c1c1;
          border-radius: 14px !important;
        "
      >
        <v-card-text max-heigth="354px">
          <v-text-field
            v-model="searchQuery"
            append-icon="ph-magnifying-glass"
            :label="$t('action.search')"
            flat
            dense
            hide-details
            solo
            background-color="#F2F2F2"
            class="search-guide"
            id="guide-search"
          >
            <template #append>
              <v-icon size="20">ph-magnifying-glass</v-icon>
            </template>
          </v-text-field>

          <v-list dense :width="355" :height="300" style="overflow: auto">
            <v-list-item
              v-for="(item, index) in filteredCompleteGuideItems"
              :key="index"
              @click="openCompleteItem(item)"
              class="px-2"
            >
              <v-list-item-content>
                <v-list-item-title
                  class="font-weight-medium"
                  style="font-size: 12px"
                  >{{ item.title }}</v-list-item-title
                >
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>ph-caret-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </div>

    <CustomDetailContent
      ref="customDetail"
      @back="selectedItem = {}"
      @close="showGuideMenu = false"
      v-else-if="selectedItem.custom && showGuideMenu"
      :item="selectedItem"
      :isItemCompleted="isCompleted(selectedItem.onboarding_code)"
      :hideCompleteButton="openedFromCompleteGuide"
      @mousedown.native.stop="startDrag($event)"
      @touchstart.native.stop.prevent="startDrag($event)"
    />

    <DetailContent
      ref="detailContent"
      @back="selectedItem = {}"
      @close="showGuideMenu = false"
      v-else-if="selectedItem.description && showGuideMenu"
      :item="selectedItem"
      @mousedown.native.stop="startDrag($event)"
      @touchstart.native.stop.prevent="startDrag($event)"
    />
  </div>
</template>
<script>
import DetailContent from "@/components/home/DetailContent.vue";
import CustomDetailContent from "@/components/home/CustomDetailContent.vue";
import { guides } from "@/helpers/variables/guides";
import { onboardings } from "@/helpers/variables/onboardings";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "Guide",
  components: { DetailContent, CustomDetailContent },
  props: {
    initOpenGuide: { type: Boolean, default: false },
  },

  data() {
    return {
      searchQuery: "",
      guideTopicsDetails: Object.values(guides),
      showGuideMenu: false,
      selectedItem: {},
      showCompleteGuide: false,
      dragOffset: { x: 0, y: 0 },
      dragStartPointer: null,
      dragPointerDiff: null,
      dragStartRect: null,
      dragStartOffset: { x: 0, y: 0 },
      dragCurrentOffset: null,
      dragReferenceElement: null,
      dragAnimationFrame: null,
      pendingTransform: { x: 0, y: 0 },
      isDragging: false,
      hasDraggedDuringInteraction: false,
      shouldPreventClick: false,
      draggingButtonOnly: false,
      skipSelectionResetOnOpen: false,
      openedFromCompleteGuide: false,
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "company",
      "conectaNuvemResellerToken",
      "companyFreshChatConfig",
      "isSupportChatOpened",
      "isChatWidgetOpened",
    ]),

    guideTopics() {
      return this.guideTopicsDetails.map((detail) => detail.title);
    },

    onboardingTopicsDetails() {
      const base = Object.values(onboardings);
      const installItem = base.find(
        (item) => item.onboarding_code === "install_extension"
      );
      const surveyAreas = this.currentUser?.survey?.areas_of_interest;

      if (
        !surveyAreas ||
        !Array.isArray(surveyAreas) ||
        surveyAreas.length === 0
      ) {
        const onboardings = base.filter(
          (item) => item.onboarding_code !== "install_extension"
        );
        return [installItem, ...onboardings];
      }

      const interestItems = base.filter(
        (item) =>
          item.onboarding_code !== "install_extension" &&
          surveyAreas.includes(item.onboarding_code)
      );

      return [installItem, ...interestItems];
    },

    didntChooseGuide() {
      return Object.keys(this.selectedItem).length === 0;
    },

    filteredGuideContent() {
      return this.guideTopics.filter((topic) =>
        topic.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },

    completeGuideItems() {
      const guidesList = this.guideTopicsDetails.map((guideItem) => ({
        type: "guide",
        title: guideItem.title,
        item: guideItem,
      }));

      const onboardingList = Object.values(onboardings).map(
        (onboardingItem) => ({
          type: "onboarding",
          title: onboardingItem.title,
          item: onboardingItem,
        })
      );

      return [...guidesList, ...onboardingList];
    },

    filteredCompleteGuideItems() {
      const formattedQuery = this.searchQuery?.toLowerCase() || "";
      return this.completeGuideItems.filter((entry) =>
        entry.title.toLowerCase().includes(formattedQuery)
      );
    },

    userOnboarding() {
      return this.currentUser?.onboardings || {};
    },

    allOnboardingsCompleted() {
      return this.onboardingTopicsDetails.every((item) =>
        this.isCompleted(item.onboarding_code)
      );
    },

    onboardingByRoute() {
      return this.onboardingTopicsDetails.reduce((routes, detail) => {
        if (detail.nextRouteName) {
          routes[detail.nextRouteName] = detail;
        }
        return routes;
      }, {});
    },
  },

  methods: {
    ...mapActions(["completeUserOnboarding"]),
    ...mapMutations(["setFloatingGuide", "setOpenGuideTip", "setSnackBar"]),

    closeFloatingGuide() {
      this.setFloatingGuide(false);
      this.setOpenGuideTip();
      this.showGuideMenu = false;

      setTimeout(() => {
        this.setOpenGuideTip(false);
      }, 8000);
    },

    openDetails(index) {
      this.selectedItem = this.guideTopicsDetails[index];
      this.openedFromCompleteGuide = false;
    },

    openOnboardingDetails(index) {
      this.openedFromCompleteGuide = false;
      this.selectedItem = this.onboardingTopicsDetails[index];
    },

    openCompleteItem(entry) {
      if (!entry) return;

      this.openedFromCompleteGuide = true;
      this.selectedItem = entry.item;
      this.showCompleteGuide = false;
      this.showGuideMenu = true;
      this.$nextTick(() => this.syncDragPosition());
    },

    isCompleted(onboarding_code) {
      if (onboarding_code === "install_extension") {
        return true;
      }

      const userOnboarding = this.userOnboarding;
      return !!(
        userOnboarding &&
        userOnboarding[onboarding_code] &&
        userOnboarding[onboarding_code].completed_at
      );
    },

    async handleCheckboxClick(item) {
      try {
        await this.completeUserOnboarding(item.onboarding_code);

        this.setSnackBar({
          show: true,
          message: `Onboarding "${item.title}" concluído!`,
          color: "success",
        });
      } catch (error) {
        console.error("Error completing onboarding:", error);

        this.setSnackBar({
          show: true,
          message: "Erro ao concluir onboarding. Tente novamente.",
          color: "error",
        });
      }
    },

    handleToggleClick() {
      if (this.shouldPreventClick) {
        this.shouldPreventClick = false;
        return;
      }

      this.showGuideMenu = !this.showGuideMenu;
      this.syncDragPosition();
    },

    getDragReferenceElement(event, button, isButton) {
      if (isButton) {
        return button;
      }

      if (event && event.currentTarget instanceof HTMLElement) {
        return event.currentTarget;
      }

      if (event && event.target instanceof HTMLElement) {
        return event.target;
      }

      return button;
    },

    startDrag(event, isButton = false) {
      if (event.type === "mousedown" && event.button !== 0) {
        return;
      }

      const pointer = this.getPointerPosition(event);
      if (!pointer) {
        return;
      }

      const button = this.$refs.dragButton ? this.$refs.dragButton.$el : null;
      if (!button) {
        return;
      }

      const referenceElement = this.getDragReferenceElement(
        event,
        button,
        isButton
      );

      if (!referenceElement) {
        return;
      }

      const rect = referenceElement.getBoundingClientRect();

      this.dragStartPointer = pointer;
      this.dragPointerDiff = {
        x: pointer.x - rect.left,
        y: pointer.y - rect.top,
      };
      this.dragStartRect = rect;
      this.dragStartOffset = { ...this.dragOffset };
      this.dragCurrentOffset = { ...this.dragOffset };
      this.dragReferenceElement = referenceElement;
      this.pendingTransform = { ...this.dragOffset };

      this.isDragging = true;
      this.hasDraggedDuringInteraction = false;
      this.draggingButtonOnly = isButton;

      if (typeof document !== "undefined" && document.body) {
        document.body.style.cursor = "grabbing";
      }

      if (isButton) {
        this.shouldPreventClick = false;
      }

      window.addEventListener("mousemove", this.onDragMove);
      window.addEventListener("mouseup", this.endDrag);
      window.addEventListener("touchmove", this.onDragMove, { passive: false });
      window.addEventListener("touchend", this.endDrag);
    },

    onDragMove(event) {
      if (!this.isDragging) {
        return;
      }

      const pointer = this.getPointerPosition(event);
      if (!pointer || !this.dragPointerDiff || !this.dragStartRect) {
        return;
      }

      const newLeft = pointer.x - this.dragPointerDiff.x;
      const newTop = pointer.y - this.dragPointerDiff.y;

      const deltaX = newLeft - this.dragStartRect.left;
      const deltaY = newTop - this.dragStartRect.top;

      const offsetX = this.dragStartOffset.x + deltaX;
      const offsetY = this.dragStartOffset.y + deltaY;

      if (!this.hasDraggedDuringInteraction) {
        const threshold = 2;
        if (Math.abs(deltaX) > threshold || Math.abs(deltaY) > threshold) {
          this.hasDraggedDuringInteraction = true;
          if (!this.draggingButtonOnly) {
            this.shouldPreventClick = true;
          }
        }
      }

      if (this.hasDraggedDuringInteraction && event.cancelable) {
        event.preventDefault();
      }

      this.dragCurrentOffset = { x: offsetX, y: offsetY };
      this.applyTransform(offsetX, offsetY);
    },

    endDrag(event) {
      if (!this.isDragging) {
        return;
      }

      if (event && event.cancelable && event.type.startsWith("touch")) {
        event.preventDefault();
      }

      this.isDragging = false;
      if (typeof document !== "undefined" && document.body) {
        document.body.style.cursor = "";
      }

      if (this.dragCurrentOffset) {
        this.dragOffset = { ...this.dragCurrentOffset };
      }

      this.dragStartPointer = null;
      this.dragPointerDiff = null;
      this.dragStartRect = null;
      this.dragStartOffset = { ...this.dragOffset };
      this.draggingButtonOnly = false;
      this.dragCurrentOffset = null;
      this.dragReferenceElement = null;
      this.pendingTransform = { ...this.dragOffset };

      if (this.dragAnimationFrame) {
        cancelAnimationFrame(this.dragAnimationFrame);
        this.dragAnimationFrame = null;
      }

      this.applyTransform(this.dragOffset.x, this.dragOffset.y);

      this.removeDragListeners();
    },

    removeDragListeners() {
      window.removeEventListener("mousemove", this.onDragMove);
      window.removeEventListener("mouseup", this.endDrag);
      window.removeEventListener("touchmove", this.onDragMove);
      window.removeEventListener("touchend", this.endDrag);
    },

    applyTransform(x = 0, y = 0) {
      this.pendingTransform = { x, y };

      if (this.dragAnimationFrame) {
        return;
      }

      this.dragAnimationFrame = window.requestAnimationFrame(() => {
        const { x: frameX, y: frameY } = this.pendingTransform || {
          x: 0,
          y: 0,
        };
        const transformValue = `translate3d(${frameX}px, ${frameY}px, 0)`;

        this.getDraggableElements().forEach((element) => {
          if (element && element.style) {
            element.style.transform = transformValue;
          }
        });

        this.dragAnimationFrame = null;
      });
    },

    getDraggableElements() {
      const elements = new Set();

      const button = this.$refs.dragButton ? this.$refs.dragButton.$el : null;
      if (button) {
        elements.add(button);
      }

      const list = this.$refs.guideList;
      if (list) {
        elements.add(list);
      }

      const complete = this.$refs.guideComplete;
      if (complete) {
        elements.add(complete);
      }

      const custom = this.$refs.customDetail
        ? this.$refs.customDetail.$el
        : null;
      if (custom) {
        elements.add(custom);
      }

      const detail = this.$refs.detailContent
        ? this.$refs.detailContent.$el
        : null;
      if (detail) {
        elements.add(detail);
      }

      if (this.dragReferenceElement) {
        elements.add(this.dragReferenceElement);
      }

      return Array.from(elements);
    },

    syncDragPosition() {
      this.$nextTick(() => {
        this.applyTransform(this.dragOffset.x, this.dragOffset.y);
      });
    },

    getPointerPosition(event) {
      if (event && event.type && event.type.startsWith("touch")) {
        const touch =
          (event.touches && event.touches[0]) ||
          (event.changedTouches && event.changedTouches[0]);

        if (!touch) {
          return null;
        }

        return { x: touch.clientX, y: touch.clientY };
      }

      if (event && event.clientX !== undefined && event.clientY !== undefined) {
        return { x: event.clientX, y: event.clientY };
      }

      return null;
    },

    evaluateRouteForAutoOpen(route) {
      if (!route || !route.name || !this.currentUser) {
        return;
      }

      const guidedCode = route.query?.guideOnboarding;
      if (guidedCode) {
        let detail = this.onboardingTopicsDetails.find(
          (item) => item.onboarding_code === guidedCode
        );
        if (!detail) {
          detail = Object.values(onboardings).find(
            (item) => item.onboarding_code === guidedCode
          );
        }

        if (detail) {
          this.showCompleteGuide = false;
          this.skipSelectionResetOnOpen = true;
          this.selectedItem = detail;
          this.showGuideMenu = true;
          this.openedFromCompleteGuide = !this.onboardingTopicsDetails.some(
            (item) => item.onboarding_code === guidedCode
          );

          this.$nextTick(() => {
            this.skipSelectionResetOnOpen = false;
            this.syncDragPosition();
          });

          return;
        }
      }

      if (route.name === "User") {
        const userOnboardingCodes = [
          "email_aliases",
          "secondary_emails",
          "drive_sharing",
          "email_delegation",
        ];

        const hasPendingUserOnboarding = userOnboardingCodes.some((code) => {
          const entry = this.userOnboarding?.[code];
          return entry && !this.isCompleted(code);
        });

        if (hasPendingUserOnboarding) {
          this.showCompleteGuide = false;
          this.skipSelectionResetOnOpen = true;
          this.selectedItem = {};
          this.showGuideMenu = true;

          this.$nextTick(() => {
            this.skipSelectionResetOnOpen = false;
            this.syncDragPosition();
          });

          return;
        }
      }

      if (this.allOnboardingsCompleted) {
        this.showGuideMenu = false;
        this.showCompleteGuide = false;
        this.selectedItem = {};
        this.syncDragPosition();
        return;
      }

      const onboardingDetail = this.onboardingByRoute[route.name];

      if (!onboardingDetail) {
        this.showGuideMenu = false;
        this.showCompleteGuide = false;
        this.selectedItem = {};
        this.syncDragPosition();
        return;
      }

      if (
        this.showGuideMenu &&
        this.selectedItem &&
        this.selectedItem.nextRouteName === route.name
      ) {
        this.syncDragPosition();
        return;
      }

      if (this.isCompleted(onboardingDetail.onboarding_code)) {
        this.showGuideMenu = false;
        this.showCompleteGuide = false;
        this.selectedItem = {};
        this.syncDragPosition();
        return;
      }

      this.showCompleteGuide = false;
      this.skipSelectionResetOnOpen = true;
      this.selectedItem = onboardingDetail;
      this.showGuideMenu = true;

      this.$nextTick(() => {
        this.skipSelectionResetOnOpen = false;
        this.syncDragPosition();
      });
    },
  },

  watch: {
    showGuideMenu(value) {
      if (value) {
        if (!this.skipSelectionResetOnOpen) {
          this.selectedItem = {};
        }
        this.skipSelectionResetOnOpen = false;
      } else {
        this.skipSelectionResetOnOpen = false;
        this.openedFromCompleteGuide = false;
      }
      this.syncDragPosition();
    },

    showCompleteGuide() {
      this.syncDragPosition();
    },

    selectedItem() {
      this.syncDragPosition();
    },

    isSupportChatOpened() {
      this.syncDragPosition();
    },

    isChatWidgetOpened() {
      this.syncDragPosition();
    },

    $route: {
      handler(route) {
        this.evaluateRouteForAutoOpen(route);
      },
    },

    currentUser(newUser, previousUser) {
      if (!previousUser && newUser) {
        this.evaluateRouteForAutoOpen(this.$route);
      }
    },
  },

  beforeMount() {
    this.showGuideMenu = this.initOpenGuide;
  },

  mounted() {
    this.evaluateRouteForAutoOpen(this.$route);
    this.syncDragPosition();
  },

  beforeDestroy() {
    this.removeDragListeners();
    if (this.dragAnimationFrame) {
      cancelAnimationFrame(this.dragAnimationFrame);
      this.dragAnimationFrame = null;
    }
    if (typeof document !== "undefined" && document.body) {
      document.body.style.cursor = "";
    }
  },
};
</script>

<style scoped>
.guide-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: "Poppins", sans-serif;
  z-index: 9999;
  background: linear-gradient(180deg, #5b36c3 0%, #f8f8f8 100%);
  max-width: 430px;
  height: auto;
  max-height: 80%;
  overflow: auto;
  border-radius: 14px;
  padding: 13px 26px 27px;
}

.float-guide {
  position: fixed;
  bottom: 8%;
  right: 20px;
}

.next-to-opened-chat {
  position: fixed;
  bottom: 9%;
  right: 400px;
}

.next-to-chat-closed {
  position: fixed;
  bottom: 9%;
  right: 90px;
}

.close {
  cursor: pointer;
  border-radius: 100%;
}

.title-guide {
  max-width: 350px;
  color: white;
  font-weight: 700;
  font-size: 18px;
  margin: 0;
  word-break: keep-all;
}

.subtitle-guide {
  max-width: 350px;
  height: 36px;
  color: white;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  margin: 0;
  word-break: keep-all;
}
.completed-text {
  text-decoration: line-through;
  color: #9e9e9e;
}

.v-card-title {
  font-weight: bold;
  font-size: 1.25rem;
  line-height: 1.2;
}

.v-list-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.updates-btn {
  color: white !important;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  border-radius: 24px;
  font-family: "Poppins", sans-serif;
}

.floating-button {
  position: fixed;
  bottom: 2%;
  right: 20px;
}

.float-with-chat-opened {
  position: fixed;
  bottom: 3%;
  right: 400px;
}

.float-with-chat-closed {
  position: fixed;
  bottom: 3%;
  right: 90px;
}

.guide-container,
.updates-btn,
.floating-button,
.float-guide,
.float-with-chat-opened,
.float-with-chat-closed,
.next-to-opened-chat,
.next-to-chat-closed,
.float-content-container,
.container-with-chat-opened,
.container-with-chat-closed {
  will-change: transform;
  cursor: grab;
}

.search-guide {
  border-radius: 12px;
}

::v-deep
  .search-guide
  .v-input__control
  .v-input__slot
  .v-text-field__slot
  input#guide-search {
  padding: 0px;
  font-size: 12px;
}

::v-deep
  .search-guide
  .v-input__control
  .v-input__slot
  .v-text-field__slot
  input#guide-search::content {
  color: #747474;
  font-size: 12px;
}

::v-deep
  .search-guide
  .v-input__control
  .v-input__slot
  .v-text-field__slot
  label {
  color: #747474;
  font-size: 12px;
  display: block;
  text-align: center;
  line-height: 150%;
}

@media only screen and (max-width: 1440px) {
  .guide-container {
    max-width: 85%;
  }
}
</style>
